import { render, staticRenderFns } from "./schoolInfoManagement.vue?vue&type=template&id=181d5a54&scoped=true&"
import script from "./schoolInfoManagement.vue?vue&type=script&lang=js&"
export * from "./schoolInfoManagement.vue?vue&type=script&lang=js&"
import style0 from "./schoolInfoManagement.vue?vue&type=style&index=0&id=181d5a54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181d5a54",
  null
  
)

export default component.exports